import i18n from "i18next";
import { logger } from "./logger";

/**
 * Translation utility for non-React components
 * @param {string} key - Translation key (can include namespace like 'common.last_seen')
 * @param {string} namespace - Translation namespace (default: null, key should include namespace)
 * @returns {string} Translated text
 */
export const translate = (key, namespace = null) => {
  try {
    // Ensure i18n is initialized
    if (!i18n.isInitialized) {
      return key;
    }

    let translationKey;
    if (namespace) {
      translationKey = `${namespace}.${key}`;
    } else {
      translationKey = key;
    }

    // Get the translation with fallback options
    const result = i18n.t(translationKey, {
      defaultValue: translationKey,
      fallbackLng: "en",
      ns: "common",
    });

    // If the result is the same as the key, it means the translation wasn't found
    if (result === translationKey) {
      // Try alternative key format
      if (key.startsWith("common.")) {
        const alternativeKey = key;
        const alternativeResult = i18n.t(alternativeKey, {
          defaultValue: alternativeKey,
          fallbackLng: "en",
          ns: "common",
        });
        if (alternativeResult !== alternativeKey) {
          return alternativeResult;
        }
      }
    }

    return result;
  } catch (error) {
    logger.error("Translation error:", error);
    return key;
  }
};
